import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Center,
  Container,
  Divider,
  Flex,
  Group,
  LoadingOverlay,
  Modal,
  Paper,
  Stack,
  Text,
  TextInput,
  ThemeIcon,
  Timeline,
  Title,
  rem,
} from "@mantine/core";
import { useDisclosure, useMediaQuery } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { showNotification } from "@mantine/notifications";
import {
  IconAddressBook,
  IconArrowLeft,
  IconCalendar,
  IconCar,
  IconCheck,
  IconCircleFilled,
  IconClock,
  IconEdit,
  IconExclamationCircle,
  IconHome,
  IconMapPin,
  IconNotes,
  IconUser,
  IconWheelchair,
  IconX,
} from "@tabler/icons-react";
import axios from "axios";
import { useEffect, useLayoutEffect, useState } from "react";
import { API_URL } from "../../services/url";
import checkUserId from "../../utils/checkuserid";
import { humenReadableTime } from "../../utils/datetime";
import { JobInfoProps, JobProps, TripProps } from "../CreateJob/type";
import { AcceptOrDeclineJob } from "./acceptordeclinejob";
import { MakePublicAndInviteUser } from "./makepublicAndinviteuser";
import { ReportJob } from "./reportjob";
import { RequestedList } from "./requestedList";
import { ResetJob } from "./resetjob";
import { ReturnJob } from "./returnjob";
import { TripDetails } from "./tripdetails";

const JobInfo = () => {
  const urlParams = new URLSearchParams(window.location.search);

  const jobId = urlParams.get("id");

  const userId = localStorage.getItem("userId");

  const isMobile = useMediaQuery("(max-width: 600px)");

  const [jobInfo, setJobInfo] = useState<JobProps | null>(null);

  const posterId = jobInfo?.posted_by?.id || jobInfo?.posted_by_user?.id;

  const [tripInfo, setTripInfo] = useState<TripProps[] | null>();

  const [loading, setLoading] = useState(true);

  const [opened, { open, close }] = useDisclosure(false);

  const [ref_number, setRef_number] = useState("");

  const [reAssigned, setReAssigned] = useState<boolean>(false);

  const [error, setError] = useState("");

  const [occurences, setOccurences] = useState<JobInfoProps[]>([]);

  const [todayJob, setTodayJob] = useState<JobInfoProps | null>(null);

  const [selectedOccurrence, setSelectedOccurrence] = useState<JobInfoProps | null>(null);

  const [isOccurrenceReassignment, setIsOccurrenceReassignment] = useState(false);

  const [hasFutureJobs, setHasFutureJobs] = useState<JobInfoProps | null>(null);

  const [requestedList, setRequestedList] = useState<string[]>([]);

  const isUser = localStorage.getItem("user") ? true : false;

  useLayoutEffect(() => {
    if (isUser) return;
    checkUserId();
  }, []);

  const fetchJob = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}job-details/${jobId}`);
      console.log("Job data received:", response.data);
      if (response.data) {
        // Handle missing location fields by using address as fallback
        const jobData = {
          ...response.data,
          pickupLoc: response.data.pickupLoc || response.data.pickup_address || 'Not specified',
          dropLoc: response.data.dropLoc || response.data.drop_address || 'Not specified'
        };

        setJobInfo(jobData);
        setOccurences(response.data.occurences || [])

        const data = response.data
        const { occurences, ...jobwithoutoccurences } = data;

        const newOccurences = [...occurences, jobwithoutoccurences];

        const now = new Date();

        const todayOccurence = newOccurences?.find(
          (occurence: JobInfoProps) => {
            return new Date(occurence.pickup_at).toLocaleDateString() === now.toLocaleDateString();
          }
        )

        const futureJobs = newOccurences?.filter((job: JobInfoProps) => {
          const pickupTime = new Date(job.pickup_at);
          console.log('checking timeings', { pickupTime, now });
          return pickupTime > now;
        });
        console.log("🚀 ~ futureJobs:", futureJobs);
        setHasFutureJobs(futureJobs && futureJobs[0]);
        setTodayJob(todayOccurence)
      } else {
        showNotification({
          title: "Error",
          message: "Job not found",
          color: "red",
        });
      }
    } catch (error) {
      showNotification({
        title: "Error",
        message: "Failed to fetch job details",
        color: "red",
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchTripDetails = async () => {
    try {
      const res = await axios.get(`${API_URL}trip-details/?job_id=${jobId}`);
      if (res.data.length === 0) return;
      else setTripInfo(res.data);
      console.log("🚀 ~ fetchTripDetails ~ res:", res.data[0]);
    } catch (error) {
      console.log("🚀 ~ fetchTripDetails ~ error:", error);
    }
  };

  useEffect(() => {
    fetchJob();
    fetchTripDetails();
  }, []);

  // handlecancel
  const handleUpdateJob = async (job: JobProps) => {
    try {
      setLoading(true);
      const cancelres = await axios.get(
        `${API_URL}jobs/${jobId}/cancel/${user ? jobInfo?.responsibledriver : posterId}/`
      );
      console.log("🚀 ~ handleUpdateJob ~ cancelres:", cancelres);
      if (cancelres.data.success) {
        if (jobInfo) setJobInfo(job);
      } else
        showNotification({
          title: "Error",
          message: "Failed to cancel job",
          color: "red",
        });
    } catch (error) {
      console.log("🚀 ~ handleUpdateJob ~ error:", error);
      showNotification({
        title: "Error",
        message: "Failed to cancel job",
        color: "red",
      });
    } finally {
      setLoading(false);
    }
  };

  //Cancelmodal
  const cancelmodal = () =>
    modals.openConfirmModal({
      title: "Are you sure want to cancel your job?",
      centered: true,
      // children: <Text size="sm">Are you sure want to Cancel your job?</Text>,
      labels: {
        confirm: "Yes, Cancel",
        cancel: "No",
      },
      onCancel: () => console.log("Cancel"),
      onConfirm: () => {
        jobInfo && handleUpdateJob({
          ...jobInfo,
          status: "cancelled",
          public: false,
          assigned_to: null,
        })
      },
      confirmProps: { color: "red" },
    });

  const style = { width: rem(16), height: rem(16) };

  const LocationIcon = <IconMapPin style={style} />;

  const CalendarIcon = <IconCalendar style={style} />;

  const CarIcon = <IconCar style={style} />;

  const WheelChairIcon = <IconWheelchair style={style} color="blue" />;

  const CheckIcon = <IconCheck style={style} color="green" />;

  const CloseIcon = <IconX style={style} color="red" />;

  const PendingIcon = <IconClock style={style} />;

  const Notes = <IconNotes style={style} />;

  const ExclamationIcon = <IconExclamationCircle style={style} />;

  const user = localStorage.getItem('user')

  const goBack = () => window.history.back();

  const canShowJob = (job: JobProps) => {
    if (posterId === userId) {
      if (job.status === "pending" || job.status === "completed" || job.status === "in_progress") {
        return true;
      }
    }

    if (job.assigned_to === userId) {
      if (job.status === "assigned" || job.status === "completed" || job.status === "in_progress") {
        return true;
      }
    }

    return false;
  };

  function HeaderCom() {
    return (
      <Paper shadow="sm" p="lg" radius="md" withBorder w="100%">
        <Group justify="space-between">
          <Group>
            <ActionIcon
              variant="light"
              color="gray"
              size="lg"
              radius="md"
              onClick={goBack}
            >
              <IconArrowLeft />
            </ActionIcon>
            <Title order={3}>Job Details</Title>
          </Group>

          {!isUser && jobInfo && (
            <Group>
              {posterId === userId &&
                jobInfo.status !== "uncovered" &&
                jobInfo.status !== "completed" && (
                  <ResetJob
                    jobId={jobId}
                    onRefetch={fetchJob}
                    jobInfo={jobInfo}
                  />
                )}
              <ReportJob jobId={jobId} />
            </Group>
          )}
        </Group>
      </Paper>
    );
  }

  if (loading) return <LoadingOverlay visible={loading} />;

  if (!loading && !jobInfo)
    return (
      <Flex w={"100vw"} h={"100vh"} justify={"center"} align={"center"}>
        <Text>{`Job details not found`}</Text>{" "}
      </Flex>
    );

  if (!jobInfo)
    return (
      <Container
        size={isMobile ? "xs" : "sm"}
        px="lg"
        py={isMobile ? "md" : "xl"}
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "self-start",
          textAlign: "left",
        }}
        bg={"bg"}
      >
        <HeaderCom />

        <Text>{`Job details not found`}</Text>
      </Container>
    );

  const isAssignedOrCreator =
    jobInfo.assigned_to === userId || posterId === userId;

  const handleReAssign = async () => {
    try {
      setLoading(true);

      const payload = isOccurrenceReassignment && selectedOccurrence
        ? {
          job_id: selectedOccurrence.id,
          driver_code: ref_number
        }
        : {
          job_id: jobId,
          driver_code: ref_number
        };

      const response = await axios.post(`${API_URL}job-assign-driver/`, payload);
      if (response.data.message.includes('successfully')) {
        setLoading(false);
        setReAssigned(true);
        setTimeout(() => {
          close();
          setReAssigned(false);
          setSelectedOccurrence(null);
          setIsOccurrenceReassignment(false);
          fetchJob();
        }, 2000);
      }
    } catch (error) {
      setLoading(false);
      console.log("🚀 ~ handleReAssign ~ error:", error);
      setError(isOccurrenceReassignment
        ? "Failed to reassign the occurrence"
        : "Failed to reassign the job");
    }
  };

  const handleOccurrenceReassign = (occurrence: JobInfoProps) => {
    setSelectedOccurrence(occurrence);
    setIsOccurrenceReassignment(true);
    setRef_number("");
    setError("");
    open();
  }

  return (
    <Container
      size={isMobile ? "xs" : "sm"}
      px="lg"
      py={isMobile ? "md" : "xl"}
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "self-start",
        textAlign: "left",
      }}
      bg={"bg"}
    >
      <HeaderCom />

      <Flex
        direction={"column"}
        justify={"space-between"}
        w={"100%"}
      // mih={"80vh"}
      >
        <Paper shadow="sm" p="xl" radius="md" my="lg">
          <Stack gap="lg">
            {/* Booking ID Header */}
            <Group justify="space-between">
              <Title order={3}>Job Details</Title>
              <Badge color="dark" size="xl" variant="filled">
                {jobInfo.booking_id}
              </Badge>
            </Group>

            {/* Pickup and Drop-off Timeline */}
            <Box>
              <Timeline active={-1} lineWidth={2} bulletSize={20}>
                <Timeline.Item
                  bullet={
                    <ThemeIcon
                      size="sm"
                      variant="light"
                      radius="xl"
                      color="teal"
                    >
                      <IconCircleFilled style={{ width: rem(12), height: rem(12) }} />
                    </ThemeIcon>
                  }
                  title={
                    <Text fw={600} size="md">
                      {jobInfo.pickup_address}
                    </Text>
                  }
                >
                  <Text size="sm" c="dimmed">
                    {jobInfo.pickupLoc || "Details not available"}
                  </Text>
                </Timeline.Item>

                <Timeline.Item
                  bullet={
                    <ThemeIcon
                      size="sm"
                      variant="light"
                      radius="xl"
                      color="gray"
                    >
                      <IconMapPin style={{ width: rem(12), height: rem(12) }} />
                    </ThemeIcon>
                  }
                  title={
                    <Text fw={600} size="md">
                      {jobInfo.drop_address || "Not specified"}
                    </Text>
                  }
                >
                  <Text size="sm" c="dimmed">
                    {jobInfo.dropLoc || "Details not available"}
                  </Text>
                </Timeline.Item>
              </Timeline>
            </Box>

            <Divider my="sm" />

            {/* Other Details */}
            <Stack gap="md">
              <Group justify="space-between">
                <Group gap="sm">
                  <ThemeIcon variant="light" color="gray">
                    <IconCalendar style={{ width: rem(16), height: rem(16) }} />
                  </ThemeIcon>
                  <Text size="sm">Pickup Date</Text>
                </Group>
                <Text size="md" fw={700}>
                  {new Date(
                    todayJob
                      ? todayJob.pickup_at
                      : hasFutureJobs
                        ? hasFutureJobs.pickup_at
                        : jobInfo.pickup_at
                  ).toLocaleDateString()}
                </Text>
              </Group>

              <Group justify="space-between">
                <Group gap="sm">
                  <ThemeIcon variant="light" color="gray">
                    <IconClock style={{ width: rem(16), height: rem(16) }} />
                  </ThemeIcon>
                  <Text size="sm">Pickup Time</Text>
                </Group>
                <Text size="sm" fw={500}>
                  {new Date(jobInfo.pickup_at).toLocaleTimeString("en-US", {
                    hour12: true,
                    hour: "numeric",
                    minute: "numeric",
                  })}
                </Text>
              </Group>

              <Group justify="space-between">
                <Group gap="sm">
                  <ThemeIcon
                    variant="light"
                    color={
                      jobInfo.services_required.includes("wheel")
                        ? "blue"
                        : "gray"
                    }
                  >
                    {jobInfo.services_required.includes("wheel") ? (
                      <IconWheelchair style={{ width: rem(16), height: rem(16) }} />
                    ) : (
                      <IconCar style={{ width: rem(16), height: rem(16) }} />
                    )}
                  </ThemeIcon>
                  <Text size="sm">Service Type</Text>
                </Group>
                <Text size="md" fw={700} tt="capitalize">
                  {jobInfo.services_required}
                </Text>
              </Group>
            </Stack>

            <Divider my="sm" />

            {/* Customer Details */}
            <Stack gap="md">
              <Group justify="space-between">
                <Group gap="sm">
                  <ThemeIcon variant="light" color="gray">
                    <IconUser style={{ width: rem(16), height: rem(16) }} />
                  </ThemeIcon>
                  <Text size="sm">Customer Name</Text>
                </Group>
                <Text size="sm" fw={500}>
                  {jobInfo.name}
                </Text>
              </Group>

              <Group justify="space-between">
                <Group gap="sm">
                  <ThemeIcon variant="light" color="gray">
                    <IconAddressBook style={{ width: rem(16), height: rem(16) }} />
                  </ThemeIcon>
                  <Text size="sm">Contact</Text>
                </Group>
                <Text size="sm" fw={500}>
                  {jobInfo.contact}
                </Text>
              </Group>

              {user && <Group justify="space-between">
                <Group gap="sm">
                  <ThemeIcon variant="light" color="gray">
                    <IconAddressBook style={{ width: rem(16), height: rem(16) }} />
                  </ThemeIcon>
                  <Text size="sm">Assigned To</Text>
                </Group>
                <Text size="sm" fw={500}>
                  {jobInfo.responsibledriver_name}
                </Text>
              </Group>}

              {jobInfo.additional_notes && (
                <Stack gap="xs">
                  <Group gap="sm">
                    <ThemeIcon variant="light" color="gray">
                      <IconNotes style={{ width: rem(16), height: rem(16) }} />
                    </ThemeIcon>
                    <Text size="sm">Additional Notes</Text>
                  </Group>
                  <Text
                    size="sm"
                    c="dimmed"
                    pl="xl"
                    ml="md"
                    style={{
                      borderLeft: `2px solid #dee2e6`,
                      paddingLeft: "10px",
                    }}
                  >
                    {jobInfo.additional_notes}
                  </Text>
                </Stack>
              )}
            </Stack>

            {isAssignedOrCreator && (
              <>
                <Divider my="sm" />
                <Group justify="space-between">
                  <Group gap="sm">
                    <ThemeIcon variant="light" color="gray">
                      {todayJob ? (
                        todayJob.status === "completed" ? (
                          <IconCheck style={{ width: rem(16), height: rem(16) }} />
                        ) : (
                          <IconExclamationCircle style={{ width: rem(16), height: rem(16) }} />
                        )
                      ) : hasFutureJobs ? (
                        <IconClock style={{ width: rem(16), height: rem(16) }} />
                      ) : jobInfo.status === "completed" ? (
                        <IconCheck style={{ width: rem(16), height: rem(16) }} />
                      ) : jobInfo.status === "cancelled" ? (
                        <IconX style={{ width: rem(16), height: rem(16) }} />
                      ) : (
                        <IconClock style={{ width: rem(16), height: rem(16) }} />
                      )}
                    </ThemeIcon>
                    <Text size="sm">Status</Text>
                  </Group>
                  <Group>
                    <Text size="sm" fw={500} tt="capitalize">
                      {jobInfo.repeat_booking
                        ? todayJob
                          ? todayJob.status
                          : hasFutureJobs
                            ? "Wait for next job"
                            : jobInfo.status
                        : jobInfo.status}
                    </Text>
                    {posterId === userId &&
                      jobInfo.status !== "completed" && (
                        <ActionIcon
                          variant="subtle"
                          color="gray"
                          aria-label="Edit Job"
                          onClick={() =>
                            (window.location.href = "/createjob?jobId=" + jobId)
                          }
                        >
                          <IconEdit
                            style={{ width: rem(16), height: rem(16) }}
                          />
                        </ActionIcon>
                      )}
                  </Group>
                </Group>
              </>
            )}
          </Stack>
        </Paper>

        {jobInfo.status === "cancelled" && (
          <Title
            order={3}
            mt={"sm"}
            ta={"center"}
            c={"red"}
          >{`Job Cancelled`}</Title>
        )}

        {/* {posterId !== userId && (
          <RequestJob jobId={jobId} jobInfo={jobInfo} />
        )} */}

        {posterId !== userId &&
          jobInfo.status !== "cancelled" &&
          jobInfo.status !== "completed" &&
          jobInfo.status !== "uncovered" &&
          jobInfo.status !== "assigned" && (
            <AcceptOrDeclineJob
              jobId={jobId}
              jobInfo={jobInfo}
              onRefetch={fetchJob}
            />
          )}

        {posterId === userId &&
          jobInfo.status !== "cancelled" &&
          jobInfo.status !== "completed" &&
          jobInfo.status !== "uncovered" && (
            <RequestedList
              jobId={jobId}
              jobInfo={jobInfo}
              onRefetch={fetchJob}
              onRequestedJobChange={requestedList => setRequestedList(requestedList)}
            />
          )}
        {(jobInfo.status === 'assigned' || jobInfo.status === 'in_progress') && (
          <Flex justify="center">
            <Text>{`Job Assigned to : ${isUser ? jobInfo.responsibledriver_name : jobInfo.assigned_driver_name}`}</Text>
          </Flex>
        )}

        {canShowJob(jobInfo) && (
          <TripDetails
            jobInfo={jobInfo}
            jobId={jobId}
            onRefetch={() => {
              fetchJob();
              fetchTripDetails();
            }}
            tripInfoArray={tripInfo}
            onReassignOccurrence={handleOccurrenceReassign}
          />
        )}

        {/* Reassign Popup */}
        <Modal
          opened={opened}
          centered
          onClose={() => {
            close();
            setSelectedOccurrence(null);
            setIsOccurrenceReassignment(false);
            setRef_number("");
            setError("");
          }}
          title={isOccurrenceReassignment
            ? `Reassign Occurrence ${selectedOccurrence?.booking_id}`
            : "Reassign the Driver"}
        >
          <Flex gap={"lg"} direction={"column"}>
            {reAssigned ? (
              <Stack gap={"xs"}>
                <Center maw={700} h={"100%"}>
                  <Flex
                    justify={"center"}
                    align={"center"}
                    w={100}
                    h={100}
                    bg={reAssigned ? "green" : "red"}
                    style={{ borderRadius: "50px" }}
                  >
                    {reAssigned ? (
                      <IconCheck
                        color="white"
                        style={{ width: rem(60), height: rem(60) }}
                      />
                    ) : (
                      <IconX
                        color="white"
                        style={{ width: rem(60), height: rem(60) }}
                      />
                    )}
                  </Flex>
                </Center>
                <Flex justify={"center"}>
                  <Text
                    mt={"lg"}
                  >
                    {isOccurrenceReassignment ? "Occurrence Reassigned Successfully" : "Reassigned Successfully"}
                  </Text>
                </Flex>
              </Stack>
            ) : (
              <Stack gap={"xs"}>
                <TextInput
                  label="Enter Referral Code"
                  placeholder="Enter Driver Referral Code"
                  type="text"
                  data-autofocus
                  size="md"
                  required
                  labelProps={{ style: { alignSelf: "flex-start" } }}
                  value={ref_number}
                  onChange={(e) => setRef_number(e.target.value)}
                  onFocusCapture={() => setError("")}
                  description={isOccurrenceReassignment && selectedOccurrence
                    ? `Reassigning occurrence for ${new Date(selectedOccurrence.pickup_at).toLocaleDateString()}`
                    : undefined
                  }
                />
                {error && (
                  <Text c="red" size="sm" my="md">
                    {error}
                  </Text>
                )}
                <Flex justify={"center"}>
                  <Button
                    w={"90%"}
                    size="md"
                    variant="gradient"
                    gradient={{ from: "#2B2B2B", to: "#404040", deg: 180 }}
                    radius={"md"}
                    c={"fcolor"}
                    mt={"lg"}
                    disabled={loading || error !== ""}
                    onClick={handleReAssign}
                    loading={loading}
                    loaderProps={{ type: "oval" }}
                  >
                    {isOccurrenceReassignment ? "Reassign Occurrence" : "Reassign"}
                  </Button>
                </Flex>
              </Stack>
            )}
          </Flex>
        </Modal>

        {(jobInfo.responsibledriver !== null && jobInfo.responsibledriver === userId) && jobInfo.assigned_to === userId &&
          jobInfo.status === 'assigned' && !tripInfo && (
            <Flex w={"100%"} justify={"center"}>
              <Button
                w={"90%"}
                radius={"md"}
                size="md"
                color="orange"
                variant="outline"
                mt={"lg"}
                disabled={loading}
                onClick={open}
                loaderProps={{ type: "oval" }}
              >
                {`Reassign the job`}
              </Button>
            </Flex>
          )
        }

        {posterId === userId &&
          !tripInfo &&
          jobInfo.status !== "cancelled" &&
          jobInfo.status !== "completed" &&
          jobInfo.status !== "uncovered" &&
          jobInfo.status !== "assigned" && (
            <MakePublicAndInviteUser
              jobId={jobId}
              jobInfo={jobInfo}
              tripInfo={tripInfo}
              onRefetch={fetchJob}
              requestedList={requestedList}
            />
          )}

        {jobInfo.assigned_to === userId &&
          !tripInfo && !isUser &&
          jobInfo.status !== "cancelled" &&
          jobInfo.status !== "completed" &&
          jobInfo.status !== "uncovered" && (
            <ReturnJob responsibledriver={jobInfo.responsibledriver} jobId={jobId} onRefetch={fetchJob} />
          )}

        {(posterId === userId || user) &&
          jobInfo.status !== "cancelled" &&
          jobInfo.status !== "completed" &&
          jobInfo.status !== "uncovered" &&
          !tripInfo && (
            <Flex justify={"center"}>
              <Button
                w={"90%"}
                size="md"
                radius={"md"}
                color="red"
                variant="outline"
                mt={"lg"}
                disabled={loading}
                onClick={cancelmodal}
                loaderProps={{ type: "oval" }}
              >
                Cancel
              </Button>
            </Flex>
          )}

        {(posterId === userId || isUser) &&
          jobInfo.status === "uncovered" &&
          !tripInfo && (
            <ResetJob jobId={jobId} onRefetch={fetchJob} jobInfo={jobInfo} />
          )}
      </Flex>
    </Container>
  );
};

export default JobInfo;
